module.exports = __webpack_public_path__ + "static/img/05.59fc642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/05.jpg
// module id = 1Gk9
// module chunks = 0